const propertyRouteRegex: RegExp =
  /^\/map\/property\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export default {
  propertyRouteRegex: propertyRouteRegex,
};
